import React from "react"
import { Link } from "gatsby"

class Layout extends React.Component
{
  render()
  {
    const { children } = this.props

    return (
      <div>
        <header>
          <nav className="nav-container">
            <Link to="/">
              paprika.studio
            </Link>
            <a target="_blank" rel="noopener noreferrer" href="https://gumroad.com/psychobiotik">
              workshops
            </a>
          </nav>
        </header>
        <main className="main-content">
          {children}
        </main>
        <footer className="footer-container">
          © {new Date().getFullYear()} Arsiliath
        </footer>
      </div>
    )
  }
}

export default Layout
